import React, { useState } from 'react';
import DeleteIcon from '../../../../../styles/svg/delete-icon.svg';
import ConfirmationDialog from '../../../../../components/Dialog/ConfirmationDialog';
import useCustomMutate from '../../../../../hooks/useMutate';
import { deleteHPDTicket } from '../../../../../sevices/violationsApi';

function DeleteHPDTicket({ params }) {
  const [dialog, setDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const { mutate } = useCustomMutate(
    deleteHPDTicket,
    ["hpd-tickets"],
    () => {
      setLoading(false);
      setDialog(false);
    },
    () => {
      setLoading(false);
      setDialog(false);
    }
  );

  const handleConfirmDelete = () => {
    setLoading(true);
    // Ticket id is used in detail route and row data
    mutate(params.row.ticket_id);
  };

  return (
    <div>
      {dialog && (
        <ConfirmationDialog
          open={dialog}
          handleClose={() => setDialog(false)}
          message={"Are you sure you want to delete this ticket?"}
          callback={handleConfirmDelete}
          loading={loading}
          btnTitle={"Delete"}
          title={"Delete Ticket"}
          btnColor="var(--dark-light-error, #B71D18)"
        />
      )}
      <img
        src={DeleteIcon}
        onClick={() => setDialog(true)}
        className="mr-1 cursor-pointer"
        alt="delete"
      />
    </div>
  );
}

export default DeleteHPDTicket;


